import { Stack, Step, StepLabel, Stepper } from '@mui/material';
import { FormikProps } from 'formik';
import { AddFromDatabaseFormValues } from './AddProductsFromDatabase';
import SelectProducts from './SelectProducts';
import AddProductsCompleted from '../AddProductsCompleted';
import VerifyPrices from './VerifyPrices';

const DatabaseSteps = (props: FormikProps<AddFromDatabaseFormValues>) => {
  const renderStep = (step: number) => {
    switch (step) {
      case 0:
        return <SelectProducts {...props} />;
      case 1:
        return <VerifyPrices {...props} />;
      case 2:
        return <AddProductsCompleted {...props} />;
    }
  };

  return (
    <Stack>
      <Stepper activeStep={props.values.activeStep} sx={{ mb: 4 }}>
        <Step>
          <StepLabel>Select Products</StepLabel>
        </Step>
        <Step>
          <StepLabel>Verify Prices</StepLabel>
        </Step>
        <Step>
          <StepLabel>Complete</StepLabel>
        </Step>
      </Stepper>
      {renderStep(props.values.activeStep)}
    </Stack>
  );
};

export default DatabaseSteps;
